import React, { useRef } from "react";
import MetaTags from "react-meta-tags";
import { Button, Container } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { Card, CardBody, Row, Col } from "reactstrap";
import { Badge } from "reactstrap";
import banner from "./avatar.jpg";
import { useState } from "react";
import { useEffect } from "react";
import { getCustomers, deleteUser } from "services/user.service";
import { getUser } from "services/user.service";
import moment from "moment";
import SuccessAlert from "components/Alerts/succes";
import ErrorAlert from "components/Alerts/error";
import BreadcrumbSub from "components/Common/BreadcrumbSub";
import Spinner from "components/spinner";
import CreateUser from "./CreateUser";
import SweetAlert from "react-bootstrap-sweetalert";
import { getPaginatedOrders } from "services/orders.service";

const UserIndex = () => {
  const badgeColor = " badge-soft-";
  const [userData, setUser] = useState({});
  console.log(userData, "user");
  const [customerData, setCustomerData] = useState([]);
  const [allList, setAllList] = useState([]);
  const [userId, setUserId] = useState();
  const [allUsersData, SetAllUsersData] = useState([]);
  const [modal, setModal] = useState(false);
  const [tab, setTab] = useState("customerData");
  const [loading, setLoading] = useState(false);
  const [activeData, setActiveData] = useState(null);
  const [success_msg, setsuccess_msg] = useState(false);
  const [error_msg, seterror_msg] = useState(false);
  const [delete_modal, setDelete_modal] = useState(false);
  const [activetab, setActivetab] = useState();
  const [nextUrl, setNextUrl] = useState("");
  const [loadMore, setLoadMore] = useState(false);
  const containerRef = useRef(null);

  const handleSearch = search => {
    if (search) {
      let tempList = _.cloneDeep(allList);
      let filterList = tempList.filter(
        ele =>
          ele?.firstname?.toLowerCase().includes(search.toLowerCase()) ||
          ele?.lastname?.toLowerCase().includes(search.toLowerCase()) ||
          ele?.email?.toLowerCase().includes(search.toLowerCase())
      );
      setCustomerData(filterList);
    } else {
      setCustomerData(allList);
    }
  };
  const toggle = () => {
    if (modal) {
      setActiveData(null);
    }
    setModal(!modal);
  };
  useEffect(() => {
    getCustomerList();
    // getUserById();
  }, []);

  const getCustomerList = () => {
    setLoading(true);
    getCustomers()
      .then(res => {
        // let Users = res?.data?.filter(ele => ele?.role !== "Admin");
        let filteredData = res?.data?.sort(
          (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt)
        );
        console.log(filteredData, "fill");
        setCustomerData(filteredData);
        setAllList(filteredData);
        SetAllUsersData(res?.data);
        // setLoading(false);
        if (res?.data.length < 10) {
          setLoadMore(false);
        } else {
          setNextUrl(res?.meta?.nextUrl);
          setLoadMore(true);
        }
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
        seterror_msg(true);
      });
  };
  const handleScroll = _.debounce(() => {
    setLoading(true);
    getPaginatedOrders(nextUrl)
      .then(res => {
        setCustomerData([...customerData, ...res?.data]);
        setAllList([...customerData, ...res?.data]);
        if (res?.data.length < 10) {
          setLoadMore(false);
        } else {
          setNextUrl(res?.meta?.nextUrl);
          setLoadMore(true);
        }
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
      });
  }, 500);
  const handleScrollEvent = () => {
    const container = containerRef.current;
    if (
      container.scrollHeight - container.scrollTop <=
        container.clientHeight + 1 &&
      loadMore
    ) {
      handleScroll();
    }
  };

  const getUserById = id => {
    setLoading(true);
    getUser(id)
      .then(res => {
        setUser(res.data);
        setLoading(false);
      })
      .catch(e => {
        console.log(e);
        setLoading(false);
      });
  };
  const handleService = (ele, index) => {
    getUserById(ele._id);
  };
  const handleDelete = id => {
    setDelete_modal(true);
    setUserId(id);
  };
  const handleOnDelete = () => {
    deleteUser(userId)
      .then(res => {
        getCustomerList();
        if (res?.data) {
          setDelete_modal(false);
          setsuccess_msg(true);
        }
      })
      .catch(err => {
        console.log(err);
        seterror_msg(true);
      });
  };
  const deletePopup = () => {
    return (
      <SweetAlert
        title="Are you sure ?"
        warning
        onConfirm={handleOnDelete}
        onCancel={stayHere}
        customButtons={
          <React.Fragment>
            <Button
              color="primary"
              className="w-md btn-sm mx-1"
              onClick={handleOnDelete}
            >
              Delete
            </Button>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={leaveToList}
            >
              cancel
            </Button>
          </React.Fragment>
        }
      >
        You will not be able to recover this record
      </SweetAlert>
    );
  };
  const leaveToList = () => {
    setsuccess_msg(false);
    seterror_msg(false);
    setDelete_modal(false);
  };
  const stayHere = () => {
    setsuccess_msg(false);
    seterror_msg(false);
  };
  const getAdminUsersAccordingToFilter = tab => {
    setLoading(true);
    if (tab === "customerData") {
      setTab("customerData");
      let Customers = allUsersData?.filter(ele => ele?.role === "Customer");
      setCustomerData(Customers);
      setLoading(false);
    } else if (tab === "AdminData") {
      setTab("AdminData");
      let AdminUsers = allUsersData?.filter(ele => ele?.role === "Admin");
      setCustomerData(AdminUsers);
      setLoading(false);
    }
  };
  const renderUserView = () => {
    return (
      <div>
        {!userData?._id && (
          <Card className="p-3 pt-0 empty_order">
            <CardBody className="border-3">
              <div className="text-center">
                <i className="mdi mdi-arrow-left-circle" id="nullCatList"></i>
              </div>
              <p className="text-center">Please Select User</p>
            </CardBody>
          </Card>
        )}

        {userData?._id && (
          <Card>
            <CardBody>
              <div className="float-end">
                <div className="text-end">
                  <Badge
                    className="font-size-12 badge-soft-info py-2 px-4 me-2"
                    color={"bg-info"}
                    pill
                  >
                    <i className="bx bx-user" />
                    &nbsp;
                    {userData?.role}
                  </Badge>
                  <Badge
                    role="button"
                    className="font-size-12 badge-soft-success py-2 px-3 me-2"
                    color={"bg-success"}
                    pill
                    onClick={() => {
                      setActiveData(userData), toggle();
                    }}
                  >
                    <i className="bx bx-pencil" />
                    &nbsp; Edit
                  </Badge>
                  <Badge
                    role="button"
                    className="font-size-12 badge-soft-danger py-2 px-3"
                    color={"bg-danger"}
                    pill
                    onClick={() => handleDelete(userData?._id)}
                  >
                    <i className="bx bxs-trash-alt" />
                    &nbsp; Delete
                  </Badge>
                </div>
              </div>
              <Row>
                <Col md={4} className="">
                  <div className="text-center">
                    <img
                      src={userData?.userImage ? userData?.userImage : banner}
                      alt=""
                      className="rounded-circle"
                      width={"200px"}
                      height={"200px"}
                    />
                    <h5 className="mt-4 text-primary">
                      {userData?.firstname}&nbsp;{userData?.lastname}
                    </h5>
                  </div>
                </Col>
                <Col md={8} className=" pt-4 mb-4 px-0 user_detail">
                  <Row className="mx-3 ps-2">
                    <p className="ps-0">
                      <span className="pe-3 fw-bold">Email </span>{" "}
                      <span className="text-muted">{userData?.email}</span>
                    </p>
                    <p className="ps-0 ">
                      <span className="pe-3 fw-bold">User ID </span>{" "}
                      <span className="text-muted">{userData?._id} </span>
                    </p>
                  </Row>
                  <div className=" mt-2 me-3 hr"> </div>
                  <Row className="mx-3 my-2">
                    <Col md={4} className="mt-4">
                      <p className="fw-bold mb-1">First Name</p>
                      <p className="text-muted">{userData?.firstname}</p>
                    </Col>
                    <Col md={4} className="mt-4">
                      <p className="fw-bold mb-1">Last Name</p>
                      <p className="text-muted">{userData?.lastname}</p>
                    </Col>
                    <Col md={4} className="mt-4">
                      <p className="fw-bold mb-1">Status</p>

                      <Badge
                        className={
                          userData?.status === "Confirmed" ||
                          userData?.status === "confirmed"
                            ? badgeColor + "success"
                            : userData?.status === "pending"
                            ? badgeColor + "warning"
                            : badgeColor + "warning"
                        }
                        color={"bg-secondary"}
                        pill
                      >
                        {userData?.status}
                      </Badge>
                    </Col>
                  </Row>

                  <Row className="mx-3 my-2">
                    <Col md={4} className="mt-4">
                      <p className="fw-bold mb-1">Created</p>
                      <p className="text-muted">
                        {moment(userData?.createdAt).format("MMM Do YYYY")}
                      </p>
                    </Col>
                    <Col md={4} className="mt-4">
                      <p className="fw-bold mb-1">Last Updated</p>
                      <p className="text-muted">
                        {moment(userData?.updatedAt).format("MMM Do YYYY")}
                      </p>
                    </Col>
                    <Col md={4} className="mt-4">
                      <p className="fw-bold mb-1">Mobile Number</p>
                      <p className="text-muted">{userData?.mobilenumber}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
      </div>
    );
  };
  const handleActiveEdit = ele => {
    setActiveData(ele);
    // ToggleCreateHotel();
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title></title>
        </MetaTags>
        <Spinner loading={loading} />
        <Container fluid>
          <Breadcrumbs title="Users" breadcrumbItem="User List" />

          <BreadcrumbSub
            subtile="Users list"
            SubBreadcrumbItem="Customer Data"
          />
          <div className="page-title-box d-sm-flex align-items-center justify-content-end">
            <h4
              className="mb-0 font-size-18 hover"
              role="button"
              style={
                tab == "customerData" ? { textDecoration: "underline" } : {}
              }
              onClick={() => getAdminUsersAccordingToFilter("customerData")}
            >
              Customers Data
            </h4>
            <span style={{ margin: "0px 8px" }}>|</span>
            <h4
              className="mb-0 font-size-18"
              role="button"
              style={tab == "AdminData" ? { textDecoration: "underline" } : {}}
              onClick={() => getAdminUsersAccordingToFilter("AdminData")}
            >
              Admin Users Data
            </h4>
            <div className="ms-4">
              <Button
                color="primary"
                className="btn btn-md"
                onClick={() => {
                  toggle();
                }}
              >
                Create User
              </Button>
            </div>
          </div>

          <Row>
            <Col md="3">
              <div>
                <div className="search-box me-2 mb-2  ">
                  <div className="position-relative">
                    <i className="bx bx-search-alt search-icon" />
                    <input
                      className="form-control py-2 rounded-pill bg-white"
                      type="search"
                      id="example-search-input"
                      placeholder=" Search for Users"
                      onChange={event => handleSearch(event.target.value)}
                    />
                  </div>
                </div>
              </div>
              <Card className="tabs Orders_tabs">
                <div
                  className="order-scroll-customer"
                  ref={containerRef}
                  onScroll={handleScrollEvent}
                >
                  {customerData &&
                    customerData.map((ele, index) => {
                      const FixedClass = "border border-bottom-2 ";
                      const activeStatusClass =
                        activetab === ele?._id
                          ? FixedClass + "bg-lightGrey"
                          : FixedClass;
                      return (
                        <CardBody
                          role="button"
                          className={activeStatusClass}
                          key={ele._id}
                          onClick={() => {
                            handleService(ele, index);
                            setActivetab(ele?._id);
                          }}
                        >
                          <Row>
                            <Col md="2">
                              <img
                                src={ele?.userImage ? ele?.userImage : banner}
                                height="50"
                                alt=""
                                className="fit-content rounded-circle avatar-sm"
                              />
                            </Col>
                            <Col md="8">
                              <div className="ms-2">
                                <small className="h6">
                                  {ele.firstname}&nbsp;{ele.lastname}
                                </small>
                                <br />
                                <small className="text-secondary">
                                  {ele.email}
                                </small>
                                <br />
                                <small className="text-secondary">
                                  {moment(ele.createdAt).format("MMM Do YYYY")}
                                </small>
                              </div>
                            </Col>
                            <Col md="2">
                              <div className="text-secondary float-end">
                                <div>
                                  <Badge
                                    className={
                                      ele.status === "Confirmed" ||
                                      ele.status === "confirmed"
                                        ? badgeColor + "success"
                                        : userData?.status === "pending"
                                        ? badgeColor + "warning"
                                        : badgeColor + "warning"
                                    }
                                    color={"bg-secondary"}
                                    pill
                                  >
                                    {ele.status}
                                  </Badge>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      );
                    })}
                </div>
              </Card>
            </Col>
            <Col md="9">{renderUserView()}</Col>
          </Row>
        </Container>
      </div>
      {success_msg ? (
        <SuccessAlert
          msg={"Successfully User deleted"}
          leaveToList={leaveToList}
          stayHere={stayHere}
        />
      ) : null}
      {error_msg ? (
        <ErrorAlert
          msg={"Something went wrong"}
          leaveToList={leaveToList}
          stayHere={stayHere}
        />
      ) : null}
      {delete_modal ? deletePopup() : null}
      <CreateUser
        toggle={toggle}
        modal={modal}
        ActiveUser={activeData}
        reload={getCustomerList}
      />
    </React.Fragment>
  );
};
export default UserIndex;
